const getCookieValue = (name: string) =>
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

function getViewportWidth() {
    return window.outerWidth;
}

function isBrowser() {
    return typeof window !== 'undefined';
}

function getBrowserInformation() {
    if (!isBrowser()) {
        return {};
    }

    const val = getCookieValue('active_session');
    const isLoggedIn = val !== 'anon' && val !== '';

    return {
        userAgent: navigator.userAgent,
        host: location.host,
        pathname: location.pathname,
        params: location.search,
        isLoggedIn,
        viewportWidth: getViewportWidth()
    };
}

export default () => {
    return {
        name: 'main-logger',
        appName: 'zoopla-website',
        environment: process.env.NODE_ENV,
        timestamp: Date.now(),
        browserLog: isBrowser(),
        ...getBrowserInformation()
    };
};
